import type { Translations } from './en.js';

const es: Translations = {
  ok: 'Aceptar', cancel: 'Cancelar', close: 'Cerrar', confirm: 'Confirmar', retry: 'Reintentar', back: 'Volver', settings: 'Ajustes', language: 'Idioma',
  score: 'Puntuacion', level: 'Nivel', game_over: 'Fin del juego', restart: 'Reiniciar', pause: 'Pausado', resume: 'Continuar',
  settings_sound: 'Sonido', settings_music: 'Musica', settings_reset: 'Reiniciar juego', settings_reset_confirm: 'Reiniciar todo el progreso?',
  ad_watch: 'Ver anuncio', ad_reward: 'Recompensa gratis', ad_loading: 'Cargando anuncio...', ad_reward_received: 'Recompensa recibida!', ad_not_completed: 'Anuncio no completado',
  offline_title: 'Bienvenido de nuevo!', offline_earned: 'Ganado mientras estabas fuera',
  sp: 'SP', fame: 'Fama', building_tab: 'Edificio', ghosts_tab: 'Fantasmas', shop_tab: 'Tienda', prestige_tab: 'Prestigio',
  training_tab: 'Entrenamiento', facilities_tab: 'Extras', reviews_tab: 'Resenas',
  floor_label: 'Piso {n}', buy_floor: 'Comprar piso', buy_floor_cost: 'Comprar piso ({sp} SP)', unlock_slot: 'Desbloquear ranura', unlock_slot_cost: 'Desbloquear ranura ({sp} SP)',
  build_room: 'Construir habitacion', upgrade_room: 'Mejorar habitacion', upgrade_room_cost: 'Mejorar ({sp} SP)', room_empty: 'Vacio', room_locked: 'Bloqueado',
  no_ghost: 'Sin fantasma', assign_ghost: 'Asignar fantasma', visitors_floor: 'Visitantes en este piso',
  add_floor: 'Agregar piso', add_floor_cost: '+ Nuevo piso ({sp} SP)', menu_tab: 'Menu',
  room_dark_corridor: 'Pasillo oscuro', room_dark_corridor_desc: 'Miedo psicologico +30%',
  room_mirror_room: 'Sala de espejos', room_mirror_room_desc: 'Visual +25%, Psicologico +15%',
  room_dungeon: 'Mazmorra', room_dungeon_desc: 'Psicologico +20%, Fisico +20%',
  room_graveyard: 'Sala del cementerio', room_graveyard_desc: 'Miedo psicologico +40%',
  room_lab: 'Laboratorio', room_lab_desc: 'Visual +30%, Fisico +20%',
  room_library: 'Biblioteca', room_library_desc: 'Psicologico +35%, Auditivo +15%',
  room_coffin_room: 'Sala del ataud', room_coffin_room_desc: 'Visual +30%, Psicologico +20%',
  room_doll_room: 'Sala de munecas', room_doll_room_desc: 'Visual +20%, Psicologico +35%',
  room_kitchen: 'Cocina maldita', room_kitchen_desc: 'Fisico +30%, Auditivo +20%',
  room_bathroom: 'Bano embrujado', room_bathroom_desc: 'Psicologico +30%, Auditivo +25%',
  room_funhouse: 'Casa de espejos',
  room_funhouse_desc: 'Visual+35%, Psicológico+20%',
  room_trapeze_room: 'Sala del trapecio',
  room_trapeze_room_desc: 'Físico+30%, Visual+15%',
  room_freak_show: 'Espectáculo de rarezas',
  room_freak_show_desc: 'Visual+40%, Psicológico+30%',
  room_sacrifice_altar: 'Altar de sacrificios',
  room_sacrifice_altar_desc: 'Psicológico+40%, Visual+20%',
  room_treasure_vault: 'Cámara del tesoro',
  room_treasure_vault_desc: 'Psicológico+20%, Auditivo+20%',
  room_underground_river: 'Río subterráneo',
  room_underground_river_desc: 'Auditivo+30%, Psicológico+20%',
  room_curse_chamber: 'Cámara de maldiciones',
  room_curse_chamber_desc: 'Psicológico+45%, Físico+15%',
  room_mummy_tomb: 'Tumba de la momia',
  room_mummy_tomb_desc: 'Visual+30%, Psicológico+30%',
  room_captain_cabin: 'Cabina del capitán',
  room_captain_cabin_desc: 'Psicológico+30%, Visual+20%',
  room_cargo_hold: 'Bodega de carga',
  room_cargo_hold_desc: 'Físico+25%, Auditivo+20%',
  room_davy_jones_locker: 'El cofre de Davy Jones',
  room_davy_jones_locker_desc: 'Psicológico+35%, Visual+25%',
  room_brig: 'Calabozo del barco',
  room_brig_desc: 'Físico+30%, Psicológico+20%',
  room_crows_nest: 'Nido del cuervo',
  room_crows_nest_desc: 'Físico+35%, Visual+20%',
  room_mine_shaft: 'Pozo de la mina',
  room_mine_shaft_desc: 'Físico+30%, Auditivo+20%',
  room_crystal_cave: 'Cueva de cristal',
  room_crystal_cave_desc: 'Visual+35%, Auditivo+15%',
  room_explosives_storage: 'Almacén de explosivos',
  room_explosives_storage_desc: 'Físico+40%, Auditivo+25%',
  room_underground_lake: 'Lago subterráneo',
  room_underground_lake_desc: 'Psicológico+30%, Auditivo+25%',
  room_rail_tunnel: 'Túnel del tren',
  room_rail_tunnel_desc: 'Físico+30%, Psicológico+20%',
  room_throne_room: 'Salón del trono',
  room_throne_room_desc: 'Visual+25%, Psicológico+30%',
  room_wine_cellar: 'Bodega de vinos',
  room_wine_cellar_desc: 'Psicológico+30%, Visual+15%',
  room_tower_chamber: 'Cámara de la torre',
  room_tower_chamber_desc: 'Psicológico+35%, Físico+20%',
  room_server_room: 'Sala de servidores',
  room_server_room_desc: 'Auditivo+30%, Visual+20%',
  room_quarantine_zone: 'Zona de cuarentena',
  room_quarantine_zone_desc: 'Psicológico+35%, Físico+20%',
  room_armory: 'Armería',
  room_armory_desc: 'Físico+35%, Visual+20%',
  room_witch_hut: 'Cabaña de la bruja',
  room_witch_hut_desc: 'Visual+30%, Psicológico+25%',
  room_treehouse: 'Casa del árbol',
  room_treehouse_desc: 'Físico+25%, Auditivo+20%',
  room_swamp_path: 'Sendero del pantano',
  room_swamp_path_desc: 'Psicológico+30%, Auditivo+20%',
  room_fairy_ring: 'Círculo de hadas',
  room_fairy_ring_desc: 'Psicológico+40%, Visual+20%',
  room_ancient_ruin: 'Ruinas antiguas',
  room_ancient_ruin_desc: 'Psicológico+35%, Visual+25%',
  room_attic: 'Ático',
  room_attic_desc: 'Psicológico+30%, Auditivo+15%',
  room_secret_passage: 'Pasaje secreto',
  room_secret_passage_desc: 'Psicológico+35%, Físico+15%',
  room_morgue: 'Morgue',
  room_morgue_desc: 'Visual+30%, Psicológico+30%',
  room_surgery_room: 'Quirófano',
  room_surgery_room_desc: 'Físico+35%, Visual+25%',
  room_music_room: 'Sala de música',
  room_music_room_desc: 'Auditivo+40%, Psicológico+20%',
  room_science_lab: 'Laboratorio de ciencias',
  room_science_lab_desc: 'Visual+30%, Físico+25%',
  room_ticket_booth: 'Taquilla',
  room_ticket_booth_desc: 'Psico+25%, Visual+20%',
  room_animal_cage: 'Jaula de Animales',
  room_animal_cage_desc: 'Fisico+30%, Visual+25%',
  room_clown_tent: 'Carpa del Payaso',
  room_clown_tent_desc: 'Psico+40%, Visual+20%',
  room_hall_of_mirrors: 'Sala de Espejos',
  room_hall_of_mirrors_desc: 'Visual+40%, Psico+30%',
  room_elevator_shaft: 'Pozo del Ascensor',
  room_elevator_shaft_desc: 'Fisico+35%, Psico+20%',
  room_ore_processing: 'Procesadora de Mineral',
  room_ore_processing_desc: 'Auditivo+30%, Fisico+20%',
  room_collapsed_tunnel: 'Tunel Derrumbado',
  room_collapsed_tunnel_desc: 'Fisico+40%, Psico+25%',
  room_miners_quarters: 'Cuartel de Mineros',
  room_miners_quarters_desc: 'Psico+30%, Visual+20%',
  room_command_center: 'Centro de Mando',
  room_command_center_desc: 'Psico+30%, Auditivo+25%',
  room_ventilation_shaft: 'Ducto de Ventilacion',
  room_ventilation_shaft_desc: 'Fisico+35%, Auditivo+25%',
  room_decontamination: 'Descontaminacion',
  room_decontamination_desc: 'Psico+35%, Visual+25%',
  room_hollow_tree: 'Arbol Hueco',
  room_hollow_tree_desc: 'Visual+30%, Psico+25%',
  room_spider_nest: 'Nido de Aranas',
  room_spider_nest_desc: 'Visual+35%, Fisico+25%',
  room_moonlit_clearing: 'Claro de Luna',
  room_moonlit_clearing_desc: 'Psico+40%, Auditivo+20%',
  room_abandoned_cabin: 'Cabana Abandonada',
  room_abandoned_cabin_desc: 'Psico+30%, Visual+20%',

  room_ward_room: 'Sala de Hospital',
  room_ward_room_desc: 'Psico+30%, Visual+20%',
  room_reception_hall: 'Recepcion',
  room_reception_hall_desc: 'Psico+25%, Audit+20%',
  room_x_ray_room: 'Sala de Rayos X',
  room_x_ray_room_desc: 'Visual+35%, Fisico+20%',
  room_classroom: 'Aula',
  room_classroom_desc: 'Psico+30%, Audit+15%',
  room_art_room: 'Sala de Arte',
  room_art_room_desc: 'Visual+35%, Psico+20%',
  room_gymnasium: 'Gimnasio',
  room_gymnasium_desc: 'Fisico+30%, Audit+25%',
  room_rooftop: 'Azotea',
  room_rooftop_desc: 'Psico+40%, Fisico+20%',
  room_crypt: 'Cripta',
  room_crypt_desc: 'Visual+35%, Psico+25%',
  room_powder_room: 'Polvorin',
  room_powder_room_desc: 'Fisico+40%, Audit+20%',
  room_navigation_room: 'Sala de Navegacion',
  room_navigation_room_desc: 'Psico+30%, Visual+20%',
  room_banquet_hall: 'Salon de Banquetes',
  room_banquet_hall_desc: 'Psico+30%, Visual+20%',
  room_chapel: 'Capilla',
  room_chapel_desc: 'Psico+40%, Audit+20%',
  room_torture_chamber: 'Camara de Tortura',
  room_torture_chamber_desc: 'Fisico+40%, Visual+30%',
  room_armory_hall: 'Sala de Armas',
  room_armory_hall_desc: 'Fisico+30%, Visual+25%',
  room_science_room: 'Laboratorio',
  room_science_room_desc: 'Visual+30%, Psico+20%',

  unlock_requires_day: 'Día {n}+',
  unlock_requires_fame: 'Fama {n}+',
  unlock_requires_room: 'Requiere: {name}',
  unlock_condition_not_met: 'Condiciones no cumplidas',
  room_repair_needed: 'Necesita reparacion', room_repairing: 'Reparando', room_cleaning: 'Limpiando',
  ghost_roster: 'Lista de fantasmas', ghost_idle: 'Inactivo', ghost_assigned: 'Asignado', ghost_fatigue: 'Fatiga',
  ghost_level: 'Nv.{n}', ghost_exp: 'EXP {cur}/{max}', ghost_level_up: 'Subir nivel',
  recover_fatigue: 'Recuperar fatiga ({sp} SP)', ghost_fatigued_warning: 'Agotado! Eficiencia -50%', unassign_ghost: 'Desasignar',
  ghost_training_in_progress: 'Entrenando...',
  shop_ghosts: 'Contratar fantasmas', shop_rooms: 'Tipos de habitacion', hire: 'Contratar', hire_cost: '{sp} SP', already_hired: 'Contratado',
  not_enough_sp: 'SP insuficiente!', unlock_room_type: 'Desbloquear', unlock_cost: '{sp} SP', already_unlocked: 'Desbloqueado',
  grade_c: 'Grado C', grade_b: 'Grado B', grade_a: 'Grado A', grade_s: 'Grado S',
  ghost_jinaeryeong: 'Fantasma coreana', ghost_gangsi: 'Jiangshi', ghost_vampire: 'Vampiro', ghost_kappa: 'Kappa', ghost_pierrot: 'Payaso', ghost_banshee: 'Banshee',
  ghost_origin_korea: 'Corea', ghost_origin_china: 'China', ghost_origin_romania: 'Rumania', ghost_origin_japan: 'Japon', ghost_origin_usa: 'EE.UU.', ghost_origin_ireland: 'Irlanda',
  ghost_jinaeryeong_skill: 'Caida de cabello: cae del techo con miedo fisico extra',
  ghost_gangsi_skill: 'Salto rigido: salta rigidamente asustando a 2 visitantes',
  ghost_vampire_skill: 'Ojos hipnoticos: congela a 1 visitante 10s, siguiente sala +30%',
  ghost_kappa_skill: 'Giro de plato: gira el plato de la cabeza para miedo visual',
  ghost_pierrot_skill: 'Ataque de risa: aparicion repentina, miedo de payaso',
  ghost_banshee_skill: 'Alarido: maximo miedo auditivo, puede activarse varias veces',
  ghost_jinaeryeong_quote: 'Asuste a 10 visitantes hoy, jefe!', ghost_gangsi_quote: 'Saltar es muy dificil...',
  ghost_vampire_quote: 'La noche es larga y yo soy eterno.', ghost_kappa_quote: 'No derames el agua!',
  ghost_pierrot_quote: 'Por que tan serio?', ghost_banshee_quote: 'Me duele la garganta de tanto gritar.',
  ghost_jinaeryeong_fatigued: 'Jefe... mi cabello esta por todos lados. Necesito descansar!',
  ghost_gangsi_fatigued: 'Ya no puedo moverme... literalmente.', ghost_vampire_fatigued: 'Hasta los inmortales necesitan descanso...',
  ghost_kappa_fatigued: 'Mi plato se seco, necesito agua!', ghost_pierrot_fatigued: 'Ya no puedo reir, jefe.',
  ghost_banshee_fatigued: 'Mi voz desaparecio! No puedo gritar!',
  room_unlock_in_shop: 'Desbloquear en tienda',
  visitor_scaredy_kid: 'Nino cobarde', visitor_scaredy_kid_desc: 'Se asusta facil pero se satisface con poco',
  visitor_normal: 'Visitante', visitor_normal_desc: 'Tolerancia al miedo promedio',
  visitor_brave: 'Valiente', visitor_brave_desc: 'Alta tolerancia, gran recompensa al satisfacerse',
  visitor_couple: 'Pareja', visitor_couple_desc: 'Miedo moderado, alta recompensa, buenas resenas',
  visitor_youtuber: 'Youtuber', visitor_youtuber_desc: 'Resenas con 2.5x influencia en fama',
  visitor_exorcist: 'Exorcista', visitor_exorcist_desc: 'Casi imposible de asustar, recompensa enorme',
  visitor_thrill_seeker: 'Buscador de emociones', visitor_thrill_seeker_desc: 'Quiere sustos intensos, impaciente con los debiles',
  visitor_coward: 'Cobarde', visitor_coward_desc: 'Aterrorizado por todo, huye facilmente',
  time_phase_day: 'Dia', time_phase_evening: 'Tarde', time_phase_night: 'Noche', time_phase_rain: 'Lluvia',
  reputation_label: 'Rep: {n}',
  scare_chain: 'Cadena x{n}!', terror_max: 'TERROR MAXIMO!', sp_earned: '+{sp} SP',
  prestige_title: 'Expansion de franquicia', prestige_desc: 'Tu casa embrujada es famosa en el mundo! Abrir una franquicia?',
  prestige_requirement_floors: 'Se requieren {n} pisos', prestige_requirement_fame: 'Se requiere Fama {n}',
  prestige_requirement_sp: 'Se requiere SP total {n}', prestige_not_ready: 'Requisitos no cumplidos',
  prestige_confirm: 'Abrir franquicia', prestige_level: 'Prestigio Nv.{n}',
  prestige_bonus: 'Todos los fantasmas +{n}% miedo, +{sp} SP inicial', offline_collect: 'Recoger',

  training_title: 'Clase de actuacion', training_select: 'Elegir entrenamiento', training_cost: '{sp} SP', training_duration: '{sec}s',
  training_in_progress: 'Entrenando...', training_complete: 'Entrenamiento completado!', training_bonus: 'Miedo +{pct}%',
  training_skip_ad: 'Saltar (Anuncio)', training_count: '{n} sesiones completadas', training_ghost_busy: 'Primero desasigna al fantasma', training_already: 'Ya entrenando',
  training_scream_practice: 'Practica de gritos', training_scream_practice_desc: 'Mejorar proyeccion vocal y tiempo',
  training_jumpscare_acting: 'Actuacion de susto', training_jumpscare_acting_desc: 'Dominar el arte de la aparicion repentina',
  training_psychological_acting: 'Horror psicologico', training_psychological_acting_desc: 'Aprender a crear terror persistente',
  training_atmosphere_directing: 'Direccion de atmosfera', training_atmosphere_directing_desc: 'Controlar luces, sonido y niebla',
  training_physical_training: 'Entrenamiento fisico', training_physical_training_desc: 'Desarrollar resistencia para sustos energeticos',
  training_audience_analysis: 'Analisis de audiencia', training_audience_analysis_desc: 'Estudiar comportamiento de visitantes',

  tq_jinaeryeong_scream: 'Fantasma coreana analizando peliculas de terror en YouTube...',
  tq_gangsi_scream: 'Jiangshi practicando gritos en posicion rigida...',
  tq_vampire_scream: 'Vampiro tarareando opera en el sotano...',
  tq_kappa_scream: 'Kappa gorgoteando gritos submarinos en un balde...',
  tq_pierrot_scream: 'Payaso gritando a un globo...', tq_banshee_scream: 'Banshee dando una masterclass a principiantes...',
  tq_jinaeryeong_jumpscare: 'Fantasma coreana saltando repetidamente de armarios...',
  tq_gangsi_jumpscare: 'Jiangshi estirando antes de practicar saltos...',
  tq_vampire_jumpscare: 'Vampiro practicando revelaciones dramaticas de capa...',
  tq_kappa_jumpscare: 'Kappa apareciendo de inodoros...', tq_pierrot_jumpscare: 'Payaso ensayando el momento del estallido del globo...',
  tq_banshee_jumpscare: 'Banshee trabajando en su coreografia de entrada...',
  tq_jinaeryeong_psych: 'Fantasma coreana estudiando libros de psicologia...',
  tq_gangsi_psych: 'Jiangshi intentando verse espeluznante (ya lo es)...',
  tq_vampire_psych: 'Vampiro practicando frente al espejo... (no se refleja)',
  tq_kappa_psych: 'Kappa aprendiendo sobre miedos humanos en la biblioteca...',
  tq_pierrot_psych: 'Payaso viendo "It" por 50a vez...', tq_banshee_psych: 'Banshee escribiendo guiones de susurros escalofriantes...',
  tq_jinaeryeong_atmo: 'Fantasma coreana arreglando su cabello para maximo efecto...',
  tq_gangsi_atmo: 'Jiangshi ajustando la maquina de niebla...',
  tq_vampire_atmo: 'Vampiro eligiendo el angulo perfecto de vela...',
  tq_kappa_atmo: 'Kappa probando diferentes sonidos de gotas de agua...',
  tq_pierrot_atmo: 'Payaso pintando paredes con pintura fosforescente...',
  tq_banshee_atmo: 'Banshee calibrando efectos de eco en el pasillo...',
  tq_jinaeryeong_physical: 'Fantasma coreana haciendo ejercicios de gateo por el techo...',
  tq_gangsi_physical: 'Jiangshi haciendo sentadillas con piernas rigidas...',
  tq_vampire_physical: 'Vampiro haciendo flexiones en su ataud...',
  tq_kappa_physical: 'Kappa nadando vueltas en el estanque...',
  tq_pierrot_physical: 'Payaso haciendo abdominales mientras hace malabares...',
  tq_banshee_physical: 'Banshee calentando las cuerdas vocales...',
  tq_jinaeryeong_audience: 'Fantasma coreana leyendo resenas de visitantes en linea...',
  tq_gangsi_audience: 'Jiangshi estudiando patrones de flujo de visitantes...',
  tq_vampire_audience: 'Vampiro analizando demografias del miedo...',
  tq_kappa_audience: 'Kappa investigando que edades temen al agua...',
  tq_pierrot_audience: 'Payaso rastreando estadisticas de coulrofobia...',
  tq_banshee_audience: 'Banshee estudiando respuestas de miedo a frecuencias sonoras...',

  props_title: 'Decoraciones de habitacion', prop_buy: 'Comprar ({sp} SP)', prop_upgrade: 'Mejorar ({sp} SP)', prop_max: 'MAX', prop_level: 'Nv.{n}', prop_bonus: '+{pct}% miedo',
  prop_cobwebs: 'Telaranas', prop_cobwebs_desc: 'Atmosfera clasica espeluznante',
  prop_candles: 'Velas parpadeantes', prop_candles_desc: 'Sombras danzantes siniestras',
  prop_blood_pool: 'Charco de sangre', prop_blood_pool_desc: 'Decoracion de piso horripilante',
  prop_skull_decor: 'Decoracion de calavera', prop_skull_decor_desc: 'Exhibicion escalofriante',
  prop_fog_machine: 'Maquina de niebla', prop_fog_machine_desc: 'Niebla espesa y misteriosa',
  prop_creaky_floor: 'Tablas crujientes', prop_creaky_floor_desc: 'Cada paso hace ruido',
  prop_eerie_painting: 'Pintura siniestra', prop_eerie_painting_desc: 'Ojos que te siguen',
  prop_chains: 'Cadenas ruidosas', prop_chains_desc: 'Sonidos metalicos espeluznantes',

  // Staging Equipment
  prop_dry_ice: 'Maquina de hielo seco', prop_dry_ice_desc: 'Crea niebla densa para atmosfera aterradora',
  prop_scent_sprayer: 'Rociador de aromas', prop_scent_sprayer_desc: 'Olores inquietantes para inmersion total',
  prop_strobe_light: 'Luz estroboscopica', prop_strobe_light_desc: 'Destellos que desorientan a los visitantes',
  prop_surround_speaker: 'Altavoz envolvente', prop_surround_speaker_desc: 'Audio espacial para efectos aterradores',
  prop_vibration_floor: 'Panel de vibracion', prop_vibration_floor_desc: 'Temblores repentinos bajo los pies',
  prop_temp_controller: 'Controlador de temperatura', prop_temp_controller_desc: 'Rafagas de aire frio para terror psicologico',
  prop_hologram_device: 'Dispositivo holografico', prop_hologram_device_desc: 'Proyecta apariciones fantasmales',
  prop_auto_lock: 'Cerradura automatica', prop_auto_lock_desc: 'Las puertas se cierran inesperadamente',
  props_category_decoration: 'Decoraciones', props_category_staging: 'Equipo de escenificacion',
  props_staging_desc: 'Equipo avanzado para efectos de terror profesional',

  facilities_title: 'Instalaciones auxiliares', facility_build: 'Construir ({sp} SP)', facility_upgrade: 'Mejorar ({sp} SP)',
  facility_level: 'Nv.{n}', facility_built: 'Construido',
  facility_haunted_house: 'Casa Embrujada', facility_haunted_house_desc: 'Edificio principal de experiencia de terror',
  facility_haunted_house_bonus: 'Entrada al edificio principal', facility_enter: 'Entrar',
  facility_ticket_booth: 'Taquilla', facility_ticket_booth_desc: 'Vende boletos de entrada a los visitantes', facility_ticket_booth_bonus: 'Aumenta la capacidad máxima de visitantes', facility_ticket_booth_visitors: 'visitantes',
  facility_gift_shop: 'Tienda de regalos', facility_gift_shop_desc: 'Vende souvenirs de la casa embrujada',
  facility_gift_shop_bonus: '+{sp} SP por grupo de visitantes',
  facility_snack_bar: 'Cafeteria', facility_snack_bar_desc: 'Snacks y bebidas espeluznantes',
  facility_snack_bar_bonus: '+{pct}% recompensa de visitantes',
  facility_photo_booth: 'Cabina de fotos', facility_photo_booth_desc: 'Estacion de selfies de terror',
  facility_photo_booth_bonus: '+{sp} SP por grupo de visitantes',

  reviews_title: 'Resenas de visitantes', reviews_empty: 'Aun no hay resenas. Espera a los visitantes!',
  reviews_fame_bonus: '+{n} Fama', review_stars: '{n} estrellas', reviews_avg: 'Promedio: {n} estrellas',
  review_5_1: 'Realmente aterrador! {ghost} en el piso 3 fue de otro nivel!',
  review_5_2: 'La mejor casa embrujada! Grite tanto que perdi la voz!',
  review_5_3: 'La actuacion de {ghost} merece un Oscar! 10/10!',
  review_5_4: 'Mi alma casi se fue. Vale cada centavo!',
  review_4_1: '{ghost} fue bastante aterrador, pero esperaba mas de los pisos superiores.',
  review_4_2: 'Gran atmosfera! Casi me hago encima. Casi.',
  review_4_3: '{ghost} fue impresionante pero el timing podria mejorar.',
  review_4_4: 'Sustos solidos. Lo recomendaria!',
  review_3_1: 'Estuvo bien. Algunas habitaciones vacias arruinaron el ambiente.',
  review_3_2: '{ghost} parecia cansado hoy. Descansa un poco?',
  review_3_3: 'Experiencia promedio. Necesita mas decoraciones.',
  review_2_1: '{ghost} estaba durmiendo en el trabajo. Reembolso por favor.',
  review_2_2: 'Mas gracioso que aterrador. Los fantasmas necesitan clases de actuacion.',
  review_2_3: '{ghost} hizo su mejor esfuerzo pero... no dio miedo.',
  review_1_1: 'Habitaciones vacias por todos lados. Esto esta abierto?',
  review_1_2: 'Quiero mi dinero de vuelta. Mi abuela da mas miedo.',
  review_1_3: '{ghost} me saludo con la mano. ME SALUDO. Asi no funciona ser fantasma.',

  review_street_5star: 'El parque entero es increible! La casa embrujada fue aterradora!', review_street_4star: 'Buena experiencia. La casa embrujada daba miedo y los snacks ricos.', review_street_3star: 'Decente. La casa embrujada necesita mas fantasmas.', review_street_2star: 'No hay mucho que hacer. La casa embrujada fue aburrida.', review_street_1star: 'Perdida de tiempo. Nada da miedo.',

  review_vip_satisfied: 'VIP: Perfect! I will definitely come back with my friends.',
  review_vip_unsatisfied: 'VIP: Very disappointing experience. Not worth my time.',

  season_halloween: 'Halloween',
  season_summer_fest: 'Summer Fest',
  season_winter_chill: 'Winter Chill',
  season_spring_bloom: 'Spring Bloom',
  ad_sp_boost: 'SP x2 (30s)', ad_sp_boost_desc: 'Duplica todas las ganancias de SP por 30 segundos',
  ad_recover_fatigue: 'Recuperacion gratis', ad_recover_fatigue_desc: 'Recupera la fatiga del fantasma gratis',
  ad_vip_visitor: 'Visitantes VIP', ad_vip_visitor_desc: 'Invoca un grupo de visitantes de alta recompensa',
  ad_skip_training: 'Saltar entrenamiento', ad_skip_training_desc: 'Completa el entrenamiento al instante',
  ad_active_boost: 'SP x2 activo!', ad_rewards_title: 'Recompensas de anuncios',

  // === Business / Open-Close System ===
  day_label: 'Dia {n}',
  hud_operation_day: 'Día {n}',
  status_open: 'ABIERTO',
  status_closed: 'CERRADO',
  manage_business: 'Manage Business',
  toggle_open: 'Abrir negocio',
  toggle_close: 'Cerrar negocio',
  facility_open_badge: 'ABIERTO',
  need_ghost_to_open: 'Asigna un fantasma a una habitacion primero!',
  ticket_price: 'Precio de entrada',
  ticket_price_label: '{n} SP',
  ticket_price_low: 'Mas visitantes, menos ingresos por visitante',
  ticket_price_high: 'Menos visitantes, mas ingresos por visitante',
  end_day: 'Terminar dia',
  day_summary_title: 'RESUMEN DEL DIA {n}',
  day_summary_visitors: 'Visitantes: {n}',
  day_summary_earnings: 'Ganancias: {n} SP',
  day_summary_avg_rating: 'Calificacion media: {n}',
  day_summary_next: 'FINALIZAR Y RECOGER',
  day_summary_best_visitor: 'Visita de {n} estrellas!',
  day_summary_sp_collected: 'SP TOTAL RECOGIDO',
  day_summary_sp_gain: '+{n}',
  day_summary_milestones: 'METAS DIARIAS',
  day_summary_total_visits: 'VISITAS TOTALES',
  day_summary_reaction_5: 'TERRORIFICA!',
  day_summary_reaction_4: 'MUY ATERRADOR!',
  day_summary_reaction_3: 'NO ESTA MAL',
  day_summary_reaction_2: 'BAH...',
  day_summary_reaction_1: 'ABURRIDO...',

  milestone_visitors_5: 'Recibir {target} visitantes',
  milestone_visitors_10: 'Recibir {target} visitantes',
  milestone_visitors_20: 'Recibir {target} visitantes',
  milestone_earnings_1000: 'Ganar {target} SP',
  milestone_earnings_5000: 'Ganar {target} SP',
  milestone_earnings_10000: 'Ganar {target} SP',
  milestone_flee_0: 'Cero visitantes huidos',
  milestone_flee_1: 'Maximo {target} visitante huido',
  milestone_rooms_3: 'Operar {target}+ habitaciones',
  milestone_rooms_5: 'Operar {target}+ habitaciones',
  milestone_ghosts_2: 'Desplegar {target}+ fantasmas',
  milestone_ghosts_3: 'Desplegar {target}+ fantasmas',
  milestone_reward: '+{n} SP',

  reviews_panel_title: 'RESENAS DE VISITANTES',
  reviews_panel_avg: 'Calificacion media',
  reviews_panel_empty: 'Aun no hay resenas',

  // --- Missing keys (English fallback) ---
  ghost_mummy: 'Mummy',
  ghost_werewolf: 'Werewolf',
  ghost_origin_egypt: 'Egypt',
  ghost_origin_europe: 'Europe',
  ghost_mummy_skill: 'Bandage Wrap: Entangles visitors, physical + visual scare',
  ghost_werewolf_skill: 'Full Moon Howl: Terrifying transformation, max physical + auditory',
  ghost_mummy_quote: 'These bandages are so itchy...',
  ghost_werewolf_quote: 'Is there a full moon tonight? I feel... different.',
  ghost_mummy_fatigued: 'My bandages came undone... I tripped...',
  ghost_werewolf_fatigued: 'Even wolves need sleep... woof... zzz...',
  tq_mummy_scream: 'Mummy practicing muffled screams through bandages...',
  tq_werewolf_scream: 'Werewolf howling at a picture of the moon...',
  tq_mummy_jumpscare: 'Mummy bursting out of sarcophagus repeatedly...',
  tq_werewolf_jumpscare: 'Werewolf practicing surprise transformations...',
  tq_mummy_psych: 'Mummy reading ancient curse scrolls for inspiration...',
  tq_werewolf_psych: 'Werewolf studying pack hunting psychology...',
  tq_mummy_atmo: 'Mummy arranging ancient Egyptian artifacts for ambiance...',
  tq_werewolf_atmo: 'Werewolf setting up moonlight projectors...',
  tq_mummy_physical: 'Mummy doing stretches to prevent bandage tangles...',
  tq_werewolf_physical: 'Werewolf doing 500 push-ups in wolf form...',
  tq_mummy_audience: 'Mummy researching which civilization visitors fear most...',
  tq_werewolf_audience: 'Werewolf tracking which visitors have dog allergies...',

  view_building: 'Edificio',
  view_other_buildings: '< Otros Edificios',
  view_lobby: 'Sala',
  view_facilities: 'Instalaciones',
  view_academy: 'Academia',
  lobby_title: 'Sala de espera',
  lobby_queue: 'Cola de espera',
  lobby_queue_empty: 'No hay visitantes esperando',
  lobby_active_teams: 'Explorando: {cur}/{max} equipos',
  lobby_wait_time: 'Espera: {n}s',
  lobby_team_size: '{n} visitantes',
  lobby_staff: 'Personal del vestibulo',
  lobby_staff_empty: 'Sin personal asignado',
  lobby_assign_staff: 'Asignar personal',
  lobby_unassign_staff: 'Retirar',
  lobby_staff_effect: 'Reduce el tiempo de espera, mejora la satisfaccion',
  lobby_ticket_booth: 'Taquilla',
  facilities_view_title: 'Gestion de instalaciones',
  facilities_view_empty: 'No hay instalaciones. Construye en el Menu!',
  facility_staff: 'Personal',
  facility_staff_none: 'Sin personal',
  facility_assign_staff: 'Asignar personal',
  facility_unassign_staff: 'Retirar personal',
  facility_staff_bonus: 'El personal mejora la calidad del servicio',
  facility_restroom: 'Banos',
  facility_restroom_desc: 'Previene penalizacion de satisfaccion',
  facility_restroom_bonus: 'Sin penalizacion al construir',
  facility_parking_lot: 'Estacionamiento',
  facility_parking_lot_desc: 'Aumenta la tasa de llegada de visitantes',
  facility_parking_lot_bonus: '+{pct}% tasa de visitantes por nivel',
  facility_first_aid: 'Enfermeria',
  facility_first_aid_desc: 'Atiende a visitantes que huyeron/se desmayaron',
  facility_first_aid_bonus: 'Previene malas resenas por huida',
  facility_arcade: 'Arcade',
  facility_arcade_desc: 'Minijuegos y atracciones de terror',
  facility_arcade_bonus: 'Aumenta la emocion de los visitantes',
  facility_fortune_teller: 'Adivino',
  facility_fortune_teller_desc: 'Lectura de tarot y palma',
  facility_fortune_teller_bonus: 'Mejora la satisfaccion',
  facility_escape_room: 'Sala de Escape',
  facility_escape_room_desc: 'Desafio de terror con limite de tiempo',
  facility_escape_room_bonus: 'Alto ingreso por visitante',
  facility_stage: 'Escenario',
  facility_stage_desc: 'Shows y actuaciones de fantasmas',
  facility_stage_bonus: 'Aumenta la fama del parque',
  facility_voodoo_shop: 'Tienda Vudu',
  facility_voodoo_shop_desc: 'Amuletos malditos y articulos magicos',
  facility_voodoo_shop_bonus: 'Mas objetos especiales',
  facility_ghost_cafe: 'Cafe Fantasma',
  facility_ghost_cafe_desc: 'Bebidas misteriosas hechas por fantasmas',
  facility_ghost_cafe_bonus: 'Visitantes se quedan mas tiempo',
  facility_phantom_cinema: 'Cine Fantasma',
  facility_phantom_cinema_desc: 'Proyeccion de peliculas de terror sobrenatural',
  facility_phantom_cinema_bonus: 'Altos ingresos por boletos',
  facility_skeleton_spa: 'Spa Esqueleto',
  facility_skeleton_spa_desc: 'Relajacion hasta los huesos',
  facility_skeleton_spa_bonus: 'Recuperacion de fatiga mas rapida',
  academy_title: 'Academia de Fantasmas',
  academy_empty: 'Contrata fantasmas primero!',
  academy_select_ghost: 'Selecciona un fantasma para entrenar',
  academy_select_training: 'Elegir curso de entrenamiento',
  academy_skill_level: 'Nv.{n}/{max}',
  academy_skill_maxed: 'DOMINADO',
  academy_training_time: '{sec}s',
  academy_training_cost: '{sp} SP',
  academy_in_progress: 'Entrenando...',
  academy_complete: 'Completado!',
  academy_skip_ad: 'Saltar (Anuncio)',
  academy_ghost_busy: 'El fantasma esta ocupado',
  academy_acting: 'Clase de actuacion',
  academy_acting_desc: 'Mejora la actuacion y el ritmo del susto',
  academy_acting_effect: 'Efecto de susto +20% por nivel',
  academy_human_relations: 'Relaciones humanas',
  academy_human_relations_desc: 'Aprende a entender a los visitantes',
  academy_human_relations_effect: 'Satisfaccion +15% por nivel',
  academy_psychology: 'Psicologia',
  academy_psychology_desc: 'Ataca las debilidades del visitante',
  academy_psychology_effect: 'Bonus de debilidad por nivel',
  academy_special_fx: 'Efectos especiales',
  academy_special_fx_desc: 'Domina el uso de accesorios y efectos',
  academy_special_fx_effect: 'Bonus de accesorios x2 por nivel',
  academy_fitness: 'Entrenamiento fisico',
  academy_fitness_desc: 'Aumenta resistencia y aguante',
  academy_fitness_effect: 'Recuperacion de fatiga +50% por nivel',
  academy_teamwork: 'Trabajo en equipo',
  academy_teamwork_desc: 'Coordina con fantasmas cercanos',
  academy_teamwork_effect: 'Susto en cadena +30% por nivel',
  academy_customer_service: 'Servicio al cliente',
  academy_customer_service_desc: 'Mejora el servicio del vestibulo/instalaciones',
  academy_customer_service_effect: 'Mejora de calidad de servicio por nivel',
  facility_detail_income: 'Ingresos',
  facility_detail_sp_per_group: '{n} SP / grupo',
  facility_detail_bonus: 'Bono',
  facility_detail_upgrade: 'Mejorar ({sp} SP)',
  facility_detail_assign: 'Asignar personal',
  facility_detail_status_active: 'Operando',
  facility_detail_status_buildable: 'Disponible',
  facility_detail_status_locked: 'Bloqueado',
  facility_detail_no_income: 'Sin ingresos directos',
  ghost_role_scare: 'Deber de susto',
  ghost_role_lobby_staff: 'Personal del vestibulo',
  ghost_role_facility_staff: 'Personal de instalacion',
  ghost_role_instructor: 'Instructor',
  shop_pro_ghosts: 'Professional Ghosts',
  pro_ghost_badge: 'PRO',
  ghost_grim_reaper: 'Grim Reaper',
  ghost_origin_underworld: 'Underworld',
  ghost_grim_reaper_skill: 'Soul Harvest: All fear types S-rank, absolute terror',
  ghost_grim_reaper_quote: 'Your time has come... just kidding. Or am I?',
  ghost_grim_reaper_fatigued: 'Even death needs a vacation sometimes...',
  ghost_grim_reaper_unique: 'Instant max fear on any visitor type',
  ghost_blood_count: 'Blood Count',
  ghost_origin_transylvania: 'Transylvania',
  ghost_blood_count_skill: 'Blood Charm: Charisma-based visual + psychological S-rank',
  ghost_blood_count_quote: 'I do not drink... wine.',
  ghost_blood_count_fatigued: 'The sun... it burns... need coffin...',
  ghost_blood_count_unique: 'Charm aura: adjacent rooms get +20% scare',
  ghost_well_spirit: 'Well Spirit',
  ghost_well_spirit_skill: 'Well Crawl: Psychological horror S-rank, lingering dread',
  ghost_well_spirit_quote: '...seven days...',
  ghost_well_spirit_fatigued: 'My hair is so tangled... need conditioner...',
  ghost_well_spirit_unique: 'Lingering fear: visitors stay scared in next room',
  ghost_nightmare_specter: 'Nightmare Specter',
  ghost_origin_dreamworld: 'Dream World',
  ghost_nightmare_specter_skill: 'Nightmare Slash: Physical + psychological S-rank dream terror',
  ghost_nightmare_specter_quote: 'Sweet dreams... or not.',
  ghost_nightmare_specter_fatigued: 'Even nightmares need beauty sleep...',
  ghost_nightmare_specter_unique: 'Dream invasion: double scare on sleeping visitors',
  ghost_shadow_stalker: 'Shadow Stalker',
  ghost_origin_void: 'The Void',
  ghost_shadow_stalker_skill: 'Static Presence: Psychological horror max, stalker-type',
  ghost_shadow_stalker_quote: '...',
  ghost_shadow_stalker_fatigued: '......',
  ghost_shadow_stalker_unique: 'Static aura: all visitors on floor get +15% fear',

  // === Visitor Reactions ===
  reaction_angry: '#!',
  reaction_excited: '*',

  lobby_room_ticket_booth: 'Taquilla',
  lobby_room_ticket_booth_desc: 'Donde los visitantes compran sus entradas',
  lobby_room_ticket_booth_effect: 'Velocidad base de venta de entradas',
  lobby_room_waiting_lounge: 'Sala de espera',
  lobby_room_waiting_lounge_desc: 'Area de espera comoda con asientos',
  lobby_room_waiting_lounge_effect: '+20% paciencia de visitantes por nivel',
  lobby_room_vip_lounge: 'Salon VIP',
  lobby_room_vip_lounge_desc: 'Sala premium para visitantes VIP',
  lobby_room_vip_lounge_effect: 'Visitantes VIP gastan 2x mas SP',
  lobby_room_reservation_center: 'Centro de reservas',
  lobby_room_reservation_center_desc: 'Sistema de reservas anticipadas',
  lobby_room_reservation_center_effect: '+15% tasa de visitantes por nivel',

  lobby_build_floor: '+ {name} ({sp} SP)',
  lobby_build_select: 'Seleccionar instalacion...',
  lobby_add_floor: '+ {sp} SP',
  lobby_empty_floor: 'Construir Instalacion',
  lobby_select_facility: 'Seleccionar Instalacion',
  lobby_props_count: '{n} accesorios',
  lobby_props_title: 'Objetos',
  lobby_tab_info: 'Info',
  lobby_tab_objects: 'Objetos',
  lobby_tab_upgrade: 'Mejorar',
  lobby_tab_demolish: 'Demoler',
  lobby_demolish_confirm: 'Eliminar esta instalacion? El piso quedara vacio.',
  lobby_demolish_btn: 'Demoler Instalacion',
  lobby_no_ghost: 'Sin personal',
  lobby_upgrade_max: 'Nivel Max',
  lobby_upgrade_next: 'Lv.{from} -> Lv.{to}',
  lobby_upgrade_effect: 'Efecto tras mejorar:',
  facility_build_floor: 'Construir',

  facility_map_title: 'Area de Instalaciones',
  facility_build_here: 'Construir',
  facility_select_to_build: 'Seleccionar Instalacion',
  facility_all_built: 'Todas las instalaciones estan construidas.',
  facility_unlock_plot: '{sp} SP',
  facility_unlock_plot_title: 'Desbloquear Parcela',
  facility_unlock_plot_desc: 'Desbloquea esta parcela por {sp} SP para construir una nueva instalacion.',
  facility_unlock_plot_btn: 'Desbloquear ({sp} SP)',
  facility_build_popup_title: 'Construir Instalacion',
  facility_build_action: 'Construir',
  facility_select_theme: 'Seleccionar Tema',
  facility_upgrade_preview: 'Efectos de Mejora',
  facility_upgrade_revenue: 'Ingreso por grupo',
  facility_upgrade_bonus: 'Bonificacion de ingreso',
  facility_upgrade_capacity: 'Capacidad',
  facility_upgrade_current: 'Actual',
  facility_upgrade_next: 'Siguiente',
  facility_upgrade_max_level: 'Nivel maximo alcanzado',
  facility_revenue: 'Ingresos',
  facility_total_revenue: 'Ingresos Totales',
  facility_hourly_revenue: 'Por Grupo',
  facility_set_price: 'Fijar Precio',
  facility_price_hint_high: 'Precio alto: mas ganancias, menos visitantes',
  facility_price_hint_low: 'Precio bajo: mas visitantes, menos ganancias',
  facility_price_hint_free: 'Entrada gratuita',
  facility_price_hint_normal: 'Precio equilibrado',
  facility_open: 'Abrir',
  facility_close: 'Cerrar',
  facility_closed_badge: 'CERRADO',
  facility_needs_staff: 'Asigna personal para abrir',
  facility_demolish: 'Demoler',
  facility_demolish_confirm: 'Demoler {name}? No se puede deshacer.',
  facility_move: 'Mover',
  facility_move_select: 'Selecciona una parcela vacia',
  facility_move_no_empty: 'No hay parcelas vacias disponibles.',

  lobby_prop_sofa: 'Sofa',
  lobby_prop_sofa_desc: 'Asientos comodos para visitantes',
  lobby_prop_tv_screen: 'Pantalla TV',
  lobby_prop_tv_screen_desc: 'Entretenimiento durante la espera',
  lobby_prop_vending_machine: 'Maquina expendedora',
  lobby_prop_vending_machine_desc: 'Snacks y bebidas para visitantes',
  lobby_prop_info_sign: 'Cartel informativo',
  lobby_prop_info_sign_desc: 'Guia a los visitantes',
  lobby_prop_potted_plant: 'Planta en maceta',
  lobby_prop_potted_plant_desc: 'Un toque de verdor siniestro',
  lobby_prop_umbrella_stand: 'Paragueero',
  lobby_prop_umbrella_stand_desc: 'Para paraguas mojados',

  fac_prop_display_shelf: 'Estanteria',
  fac_prop_display_shelf_desc: 'Exhibir productos atractivamente',
  fac_prop_cash_register: 'Caja registradora',
  fac_prop_cash_register_desc: 'Acelerar transacciones',
  fac_prop_coffee_machine: 'Cafetera',
  fac_prop_coffee_machine_desc: 'Servir bebidas calientes',
  fac_prop_menu_board: 'Tablero de menu',
  fac_prop_menu_board_desc: 'Mostrar opciones de comida',
  fac_prop_camera_light: 'Luz de camara',
  fac_prop_camera_light_desc: 'Mejor iluminacion para fotos',
  fac_prop_backdrop: 'Telon de fondo',
  fac_prop_backdrop_desc: 'Fondo tematico para fotos',
  fac_prop_hand_dryer: 'Secador de manos',
  fac_prop_hand_dryer_desc: 'Mantener todo limpio y seco',
  fac_prop_mirror: 'Espejo',
  fac_prop_mirror_desc: 'Esencial de bano espeluznante',
  fac_prop_parking_sign: 'Senal de estacionamiento',
  fac_prop_parking_sign_desc: 'Dirigir visitantes al parking',
  fac_prop_barrier_gate: 'Barrera',
  fac_prop_barrier_gate_desc: 'Control automatico de parking',
  fac_prop_first_aid_kit: 'Botiquin',
  fac_prop_first_aid_kit_desc: 'Suministros medicos basicos',
  fac_prop_stretcher: 'Camilla',
  fac_prop_stretcher_desc: 'Para visitantes desmayados del susto',

  tab_facilities: 'Instalaciones',
  tab_hire: 'Contratar',
  tab_staff: 'Personal',
  tab_support_facilities: 'Instalaciones',
  tab_achievements: 'Logros',
  achievements_title: 'Logros',
  achievements_coming_soon: 'Proximamente...',
  facilities_mgmt_title: 'Gestion de Instalaciones',
  facility_condition: 'Estado',
  facility_hygiene: 'Higiene',
  facility_condition_warning: 'Necesita reparacion!',
  facility_hygiene_warning: 'Necesita limpieza!',
  dispatch_repair: 'Enviar reparador',
  dispatch_clean: 'Enviar limpieza',
  no_repair_staff: 'Sin personal de reparacion',
  no_janitor_staff: 'Sin personal de limpieza',
  repair_dispatched: 'Reparador enviado',
  clean_dispatched: 'Limpieza enviada',
  ticket_section_title: 'Precio de entrada',
  expected_visitors: 'Visitantes esperados: ~{n}/dia',
  star_rating_title: 'Evaluacion de visitantes',
  star_level_gray: 'Estrella gris',
  star_level_bronze: 'Estrella bronce',
  star_level_silver: 'Estrella plata',
  star_level_gold: 'Estrella oro',
  star_level_rainbow: 'Estrella arcoiris',
  star_evolution_max: 'La mejor casa embrujada',
  star_current: '{cur}/{max}',
  hire_title: 'Contratar personal',
  hire_scare_section: 'Especialistas en susto',
  hire_staff_section: 'Personal de instalaciones',
  staff_role_repair: 'Reparador',
  staff_role_janitor: 'Limpiador',
  staff_role_ticket: 'Vendedor de boletos',
  staff_role_guide: 'Guia',
  staff_role_repair_desc: 'Repara el deterioro',
  staff_role_janitor_desc: 'Mantiene la higiene',
  staff_role_ticket_desc: 'Opera el vestibulo',
  staff_role_guide_desc: 'Bonus de satisfaccion',
  hire_cost_label: '{sp} SP',
  staff_title: 'Lista de personal',
  staff_empty: 'Sin personal contratado.',
  staff_detail_title: 'Detalle del personal',
  staff_detail_type: 'Tipo',
  staff_detail_role: 'Rol',
  staff_detail_grade: 'Grado',
  staff_detail_skills: 'Habilidades',
  staff_detail_assigned: 'Asignado a',
  staff_detail_not_assigned: 'Sin asignar',
  staff_detail_hired_days: 'Contratado: Dia {n}',
  staff_detail_praise: 'Elogios: {n}',
  skill_acting: 'Actuacion',
  skill_friendliness: 'Amabilidad',
  skill_psychology: 'Psicologia',
  skill_special_fx: 'Efectos especiales',
  skill_fitness: 'Estado fisico',
  skill_teamwork: 'Trabajo en equipo',
  skill_service: 'Atencion al cliente',
  room_detail_tab_info: 'Info',
  room_detail_tab_props: 'Objetos',
  room_detail_tab_upgrade: 'Mejora',
  room_detail_tab_demolish: 'Demoler',
  room_detail_ghost_none: 'Sin asignar',
  room_detail_condition: 'Estado',
  room_detail_hygiene: 'Higiene',
  room_detail_request_repair: 'Pedir reparacion ({sp} SP)',
  room_detail_request_cleaning: 'Pedir limpieza ({sp} SP)',
  room_detail_repairing: 'Reparando... {sec}s',
  room_detail_cleaning: 'Limpiando... {sec}s',
  room_detail_collapsed: 'DERRUMBADO',
  room_detail_collapsed_desc: 'La sala se derrumbo. Repara para restaurar.',
  room_detail_condition_ok: 'Estado bueno',
  room_detail_hygiene_ok: 'Higiene buena',
  room_upgrade_structure: 'Refuerzo Estructural',
  room_upgrade_structure_desc: 'Reduce el deterioro por visita',
  room_upgrade_structure_effect: '-{pct}% deterioro por nivel',
  room_upgrade_structure_bonus_10: 'Sala Resistente: Coste de reparacion -30%',
  room_upgrade_structure_bonus_20: 'Sala Inmortal: Estado minimo 50',
  room_upgrade_purify: 'Auto Purificacion',
  room_upgrade_purify_desc: 'Reduce la perdida de higiene por visita',
  room_upgrade_purify_effect: '-{pct}% perdida de higiene por nivel',
  room_upgrade_purify_bonus_10: 'Sala Fragante: Satisfaccion +10%',
  room_upgrade_purify_bonus_20: 'Magia de Limpieza: Recuperacion automatica',
  room_upgrade_level: 'Nv.{cur}/{max}',
  room_upgrade_cost: 'Mejorar ({sp} SP)',
  room_upgrade_max: 'MAX',
  room_upgrade_bonus_unlocked: 'Desbloqueado!',
  room_upgrade_bonus_locked: 'Bonus Nv.{n}',
  room_demolish_warning: 'Demoler esta sala destruira todos los objetos y mejoras permanentemente.',
  room_demolish_cost: 'Coste: Gratis',
  room_demolish_btn: 'Demoler Sala',
  room_demolish_confirm: 'Seguro que quieres demoler esta sala? No se puede deshacer.',
  room_props_installed: 'Objetos Instalados',
  room_props_available: 'Objetos Disponibles',
  room_props_none: 'Sin objetos',
  menu_bgm: 'BGM',
  menu_sfx: 'SFX',
  menu_language: 'Idioma',
  menu_reset: 'Reiniciar juego',
  menu_reset_confirm: 'Seguro que quieres reiniciar? No se puede deshacer.',
  menu_info: 'Info del juego',
  menu_version: 'Version {v}',
  menu_on: 'ON',
  menu_off: 'OFF',

  // === Room Emotion Stats ===
  stat_fear: 'Miedo',
  stat_thrill: 'Emocion',
  stat_atmosphere: 'Ambiente',
  stat_fun: 'Diversion',
  stat_total: 'Atributos',
  room_grade: 'Grado',
  grade_S: 'S',
  grade_A: 'A',
  grade_B: 'B',
  grade_C: 'C',
  grade_D: 'D',
  grade_F: 'F',

  phase_day: 'Prep',
  phase_evening: 'Abierto',
  phase_night: 'Cerrado',
  phase_day_icon: '\u2600',
  phase_evening_icon: '\uD83C\uDF19',
  phase_night_icon: '\u2B50',
  phase_remaining: '{sec}s',
  phase_day_hint: 'Prepara tu casa embrujada! Repara, asigna fantasmas, mejora.',
  phase_evening_hint: 'Horario comercial! Los visitantes vienen.',
  open_now_btn: 'ABRIR AHORA',
  speed_btn: 'x{n}',
  day_auto_open_hint: 'Ha llegado la tarde! Hora de abrir.',
  evening_ending_hint: 'Hora de cierre! Cerrando...',
  floor1_blocked_warning: 'Entrada bloqueada! Repara el Piso 1!',
  gstaff_title: 'Fantasmas Staff',
  gstaff_repairman: 'Fantasma Reparador',
  gstaff_repairman_desc: 'Un fantasma que atraviesa paredes para reparar salas',
  gstaff_repairman_effect: 'Repara la habitacion con menor condicion',
  gstaff_janitor: 'Fantasma Limpiador',
  gstaff_janitor_desc: 'Limpia salas con energia espectral',
  gstaff_janitor_effect: 'Limpia la habitacion con menor higiene',
  gstaff_promoter: 'Fantasma Promotor',
  gstaff_promoter_desc: 'Atrae visitantes con susurros espeluznantes',
  gstaff_promoter_effect: '+20% visitantes por nivel',
  gstaff_medic: 'Fantasma Sanador',
  gstaff_medic_desc: 'Calma visitantes asustados con encanto fantasmal',
  gstaff_medic_effect: 'Los visitantes que huyen dejan resenas neutrales',
  gstaff_security: 'Fantasma Guardian',
  gstaff_security_desc: 'Mantiene el orden con presencia intimidante',
  gstaff_security_effect: '+10% satisfaccion por nivel',
  gstaff_hire_cost: 'Invocar: {sp} SP',
  gstaff_salary: 'Mantenimiento: {sp} SP/dia',
  gstaff_fire: 'Exorcizar',
  gstaff_fire_confirm: 'Exorcizar a este fantasma?',
  gstaff_level: 'Nv.{n}',
  gstaff_none: 'No hay fantasmas invocados.',
  day_summary_salaries: 'Salarios',
  day_summary_net_earnings: 'Ganancias Netas',
  day_summary_street_visitors: 'Visitantes Callejeros',
  day_summary_street_revenue: 'Ingresos Callejeros',
  day_summary_reviews_title: 'RESENAS DE VISITANTES',
  day_summary_avg_stars: 'PUNTUACION MEDIA',
  day_summary_fame_change: 'FAMA',
  day_summary_no_reviews: 'Sin resenas hoy',
  day_summary_review_visitor: 'Visitante #{n}',
  day_summary_highlight: 'DESTACADO',

  // === Tutorial ===
  tutorial_welcome_title: 'Bienvenido a la Casa Embrujada!',
  tutorial_welcome_body: 'Desde hoy eres el dueno de esta casa embrujada. Crea la casa embrujada mas divertida con tus fantasmitas!',
  tutorial_welcome_btn: 'Empecemos!',
  tutorial_build_title: 'Construir una habitacion',
  tutorial_build_body: 'Primero, construyamos una habitacion. Toca el boton "+" para elegir un tipo de habitacion.',
  tutorial_ghost_title: 'Asignar un fantasma',
  tutorial_ghost_body: 'Asigna un fantasma a la habitacion para asustar a los visitantes. Toca la habitacion para asignar un fantasma.',
  tutorial_open_title: 'Abrir la casa',
  tutorial_open_body: 'Todo listo! Toca el boton "Abrir" de abajo para recibir visitantes.',
  tutorial_facility_intro_title: 'Area de Instalaciones',
  tutorial_facility_intro_body: 'Tu parque tiene parcelas para instalaciones! Construye tiendas y atracciones para ganar mas.',
  tutorial_facility_build_title: 'Construir Instalacion',
  tutorial_facility_build_body: 'Toca una parcela vacia y elige una instalacion. Prueba la Tienda de Regalos o el Snack Bar!',
  tutorial_facility_staff_title: 'Asignar Personal',
  tutorial_facility_staff_body: 'Asigna un fantasma a tu nueva instalacion. El personal aumenta los ingresos un 20%!',
  tutorial_facility_open_title: 'Abrir Instalacion',
  tutorial_facility_open_body: 'Abre tu instalacion para que los visitantes la usen. Tambien puedes fijar precios!',
  tutorial_done_title: 'Tutorial completado!',
  tutorial_done_body: 'Genial! Ya dominas las operaciones basicas. Sigue expandiendo tu casa embrujada!',
  tutorial_skip: 'Saltar',
  tutorial_next: 'Siguiente',
  tutorial_got_it: 'Entendido!',

  // === Story Arc System ===
  story_intro: 'Intro',
  story_rising: 'Ascenso',
  story_climax: 'Climax',
  story_resolution: 'Desenlace',
  story_grade: 'Arco: {grade} (+{bonus}% SP)',
  story_bonus: '+{bonus}% SP',
  story_guide_title: 'Sistema de Arco Narrativo Desbloqueado!',
  story_guide_desc: 'Con 4+ salas, organiza tus pisos para crear un arco narrativo y ganar SP extra!',
  story_role_label: '{role}',
  story_intro_desc: 'Crear ambiente: alta atmosfera, bajo miedo',
  story_rising_desc: 'Aumentar tension: incrementar miedo y emocion',
  story_climax_desc: 'Terror maximo: miedo y emocion al maximo',
  story_resolution_desc: 'Alivio y diversion: aumentar diversion',
  story_room_role: 'Rol narrativo: {role}',
  story_none: 'Ninguno',

  // === Room Available Props ===
  room_available_props: 'Instalables: {props}',

  // === Lobby Queue System ===
  lq_waiting_count: 'Espera: {n}/{max}',
  lq_avg_patience: 'Paciencia media: {n}%',
  lq_queue_empty: 'No hay visitantes en la cola',

  // === Lobby Facilities ===
  lf_title: 'Instalaciones del vestibulo',
  lf_patience_bonus: 'Paciencia -{n}%',
  lf_revenue_bonus: '+{n} SP/visitante',
  lf_npc_bonus: 'NPC: +15% paciencia, +20% ingresos',
  lf_npc_staff: 'Personal NPC',

  lf_ticket_booth: 'Taquilla',
  lf_ticket_booth_desc: 'Mostrador esencial de venta de entradas',
  lf_waiting_lounge: 'Sala de espera',
  lf_waiting_lounge_desc: 'Area de espera comoda con asientos (+paciencia)',
  lf_vip_lounge: 'Salon VIP',
  lf_vip_lounge_desc: 'Sala premium para visitantes VIP',
  lf_reservation_center: 'Centro de reservas',
  lf_reservation_center_desc: 'Sistema de reserva previa (+paciencia)',
  lf_poster_wall: 'Muro de posters',
  lf_poster_wall_desc: 'Posters espeluznantes aumentan la expectativa (+paciencia)',
  lf_snack_cart: 'Carrito de snacks',
  lf_snack_cart_desc: 'Los snacks mantienen la paciencia de los visitantes',
  lf_souvenir_booth: 'Puesto de recuerdos',
  lf_souvenir_booth_desc: 'Vende recuerdos para ingresos extra',
  lf_photo_zone: 'Zona de fotos',
  lf_photo_zone_desc: 'Los visitantes toman fotos, aumentando fama e ingresos',
  lf_tv_monitor: 'Monitor TV',
  lf_tv_monitor_desc: 'Videos de terror mantienen entretenidos a los visitantes',
  lf_costume_rental: 'Alquiler de disfraces',
  lf_costume_rental_desc: 'Los visitantes alquilan disfraces para mas diversion e ingresos',
  lf_fortune_booth: 'Puesto de fortuna',
  lf_fortune_booth_desc: 'Adivinacion misteriosa crea atmosfera de terror',
  lf_built_badge: 'Construido',

  // === Lobby Facility Unique Effects ===
  lf_ue_ticket_speed: 'Velocidad de taquilla: intervalo de entrada -15% por nivel',
  lf_ue_max_queue_up: 'Capacidad: cola maxima +5 por nivel',
  lf_ue_vip_rate_up: 'Tasa VIP: aparicion VIP x2 por nivel',
  lf_ue_satisfaction_up: 'Anticipacion: satisfaccion base +20%',
  lf_ue_emergency_patience: 'Bocadillo de emergencia: +15 paciencia para visitantes bajos',
  lf_ue_revisit_rate_up: 'Recuerdos: bonus de visitantes del dia siguiente +15%',
  lf_ue_reputation_per_day: 'Compartir SNS: reputacion diaria +2 por nivel',
  lf_ue_anticipation_up: 'Vista previa de terror: aumento de emocion +40%',
  lf_ue_fun_bonus: 'Disfraces: stat de diversion +15 por nivel',
  lf_ue_random_sp_bonus: 'Fortuna: probabilidad de bonus SP aleatorio +10%',
  ticket_price_setting: 'Precio de entrada',

  // === Lobby Facility Props ===
  lobby_prop_candle: 'Vela',
  lobby_prop_candle_desc: 'Una vela parpadeante para ambiente',
  lobby_prop_cobweb: 'Telarana',
  lobby_prop_cobweb_desc: 'Telaranas escalofriantes',
  lobby_prop_pumpkin: 'Calabaza',
  lobby_prop_pumpkin_desc: 'Linterna de calabaza clasica',
  lobby_prop_magazine_rack: 'Revistero',
  lobby_prop_magazine_rack_desc: 'Revistas de terror para esperar',
  lobby_prop_chandelier: 'Candelabro',
  lobby_prop_chandelier_desc: 'Elegante candelabro gotico',
  lobby_prop_wine_glass: 'Copa de vino',
  lobby_prop_wine_glass_desc: 'Copas de cristal para ambiente VIP',
  lobby_prop_velvet_curtain: 'Cortina de terciopelo',
  lobby_prop_velvet_curtain_desc: 'Lujosas cortinas de terciopelo',
  lobby_prop_gold_frame: 'Marco dorado',
  lobby_prop_gold_frame_desc: 'Marco de foto dorado ornamental',
  lobby_prop_picture_frame: 'Marco de foto',
  lobby_prop_picture_frame_desc: 'Retrato maldito en la pared',
  lobby_prop_spotlight: 'Foco',
  lobby_prop_spotlight_desc: 'Iluminacion dramatica para exposiciones',
  lobby_prop_skull_ornament: 'Ornamento de craneo',
  lobby_prop_skull_ornament_desc: 'Craneo decorativo escalofriante',
  lobby_prop_pumpkin_cookie: 'Galleta de calabaza',
  lobby_prop_pumpkin_cookie_desc: 'Deliciosas galletas en forma de calabaza',
  lobby_prop_ghost_drink: 'Bebida fantasma',
  lobby_prop_ghost_drink_desc: 'Bebida misteriosa brillante',
  lobby_prop_napkin_holder: 'Servilletero',
  lobby_prop_napkin_holder_desc: 'Mantiene el area de bocadillos ordenada',
  lobby_prop_display_shelf: 'Estante de exhibicion',
  lobby_prop_display_shelf_desc: 'Muestra recuerdos de forma atractiva',
  lobby_prop_plush_doll: 'Muneco de peluche',
  lobby_prop_plush_doll_desc: 'Lindo peluche fantasma',
  lobby_prop_keychain_rack: 'Soporte de llaveros',
  lobby_prop_keychain_rack_desc: 'Soporte giratorio de llaveros escalofriantes',
  lobby_prop_wrapping_paper: 'Papel de regalo',
  lobby_prop_wrapping_paper_desc: 'Papel de regalo tematico de Halloween',
  lobby_prop_backdrop: 'Fondo',
  lobby_prop_backdrop_desc: 'Fondo de fotos tematico',
  lobby_prop_prop_box: 'Caja de accesorios',
  lobby_prop_prop_box_desc: 'Caja de accesorios divertidos para fotos',
  lobby_prop_mask_stand: 'Soporte de mascaras',
  lobby_prop_mask_stand_desc: 'Exhibicion de mascaras espeluznantes para fotos',
  lobby_prop_antenna: 'Antena',
  lobby_prop_antenna_desc: 'Receptor de senal de TV',
  lobby_prop_remote_control: 'Control remoto',
  lobby_prop_remote_control_desc: 'Controla los canales de TV',
  lobby_prop_speaker: 'Altavoz',
  lobby_prop_speaker_desc: 'Sonido envolvente para peliculas de terror',
  lobby_prop_cable_wires: 'Cables',
  lobby_prop_cable_wires_desc: 'Cables enredados anaden un toque escalofriante',
  lobby_prop_clothes_rack: 'Perchero',
  lobby_prop_clothes_rack_desc: 'Perchero con disfraces escalofriantes',
  lobby_prop_mirror: 'Espejo',
  lobby_prop_mirror_desc: 'Espejo de cuerpo entero para revisar disfraces',
  lobby_prop_makeup_table: 'Mesa de maquillaje',
  lobby_prop_makeup_table_desc: 'Aplica maquillaje espeluznante aqui',
  lobby_prop_wig_stand: 'Soporte de pelucas',
  lobby_prop_wig_stand_desc: 'Coleccion de pelucas escalofriantes',
  lobby_prop_crystal_ball: 'Bola de cristal',
  lobby_prop_crystal_ball_desc: 'Ve tu espeluznante futuro',
  lobby_prop_tarot_cards: 'Cartas de tarot',
  lobby_prop_tarot_cards_desc: 'Cartas de adivinacion misteriosas',
  lobby_prop_curtain: 'Cortina',
  lobby_prop_curtain_desc: 'Cortina mistica para el puesto de fortuna',
  lobby_prop_candelabra: 'Candelabro',
  lobby_prop_candelabra_desc: 'Candelabro de multiples brazos para ambiente',

  lnpc_title: 'Lobby Ghost Patrol',
  lnpc_assign: 'Assign Ghost',
  lnpc_unassign: 'Remove',
  lnpc_desc: 'Ghosts scare waiting visitors, boosting patience',
  lnpc_slot: '{cur}/{max} Ghosts',
  evt_time_remaining: '{sec}s remaining',
  evt_rain_name: 'Sudden Rain',
  evt_rain_desc: 'Heavy rain falls suddenly. Visitors without umbrellas are leaving the queue.',
  evt_rain_c1: 'Ignore',
  evt_rain_c2: 'Hand out umbrellas (100 SP)',
  evt_rain_r1: '3 visitors left the queue in the rain.',
  evt_rain_r2: 'Umbrellas were handed out. Everyone stays dry.',
  evt_couple_fight_name: 'Couple Fight',
  evt_couple_fight_desc: 'A couple starts arguing loudly in the queue, disturbing others.',
  evt_couple_fight_c1: 'Handle it',
  evt_couple_fight_r1: 'The situation has been dealt with.',
  evt_crying_child_name: 'Crying Child',
  evt_crying_child_desc: 'A child starts crying in the queue, making others uneasy.',
  evt_crying_child_c1: 'Give candy (50 SP)',
  evt_crying_child_c2: 'Ignore',
  evt_crying_child_r1: 'The candy cheered the child up.',
  evt_crying_child_r2: 'The crying continued, testing everyone\'s patience.',
  evt_blackout_name: 'Power Outage',
  evt_blackout_desc: 'A sudden power outage plunges everything into darkness.',
  evt_blackout_c1: 'Start generator (200 SP)',
  evt_blackout_c2: 'Wait it out',
  evt_blackout_r1: 'The generator kicked in. Business continues.',
  evt_blackout_r2: 'Everyone waited in the dark for a while.',
  evt_line_cutter_name: 'Line Cutter',
  evt_line_cutter_desc: 'Someone brazenly cuts into the front of the queue.',
  evt_line_cutter_c1: 'Call security',
  evt_line_cutter_c2: 'Ignore',
  evt_line_cutter_r1: 'Security escorted the line cutter out.',
  evt_line_cutter_r2: 'Others in line grumble in frustration.',
  evt_fake_ghost_name: 'Fake Ghost Prank',
  evt_fake_ghost_desc: 'A visitor dressed as a ghost is scaring others in line. The crowd seems amused.',
  evt_fake_ghost_c1: 'Let them have fun',
  evt_fake_ghost_r1: 'The prank added to the spooky atmosphere. Reputation up!',
  evt_lost_item_name: 'Lost Item Report',
  evt_lost_item_desc: 'A visitor reports a lost item near the entrance.',
  evt_lost_item_c1: 'Help find it (Reputation +5)',
  evt_lost_item_c2: 'Ignore',
  evt_lost_item_r1: 'The lost item was found! The visitor is grateful.',
  evt_lost_item_r2: 'The visitor left disappointed.',
  evt_snack_sold_out_name: 'Snacks Sold Out',
  evt_snack_sold_out_desc: 'The snack cart ran out of stock. Visitors are asking for snacks.',
  evt_snack_sold_out_c1: 'Emergency restock (100 SP)',
  evt_snack_sold_out_c2: 'Wait for next shipment',
  evt_snack_sold_out_r1: 'Snacks are back in stock.',
  evt_snack_sold_out_r2: 'Visitors will have to wait.',
  evt_sns_selfie_name: 'SNS Photo Op',
  evt_sns_selfie_desc: 'A visitor wants to take a selfie for social media.',
  evt_sns_selfie_c1: 'Acknowledge',
  evt_sns_selfie_r1: 'The post boosted your online presence.',
  evt_hot_weather_name: 'Scorching Heat',
  evt_hot_weather_desc: 'The temperature soars. Visitors look uncomfortable in the heat.',
  evt_hot_weather_c1: 'Free drinks (150 SP)',
  evt_hot_weather_c2: 'Endure it',
  evt_hot_weather_r1: 'Cool drinks refreshed everyone.',
  evt_hot_weather_r2: 'The heat is taking a toll on patience.',
  evt_tour_bus_name: 'Tour Bus Arrival',
  evt_tour_bus_desc: 'A tour bus just arrived! A large group of tourists floods the entrance.',
  evt_tour_bus_c1: 'Welcome them',
  evt_tour_bus_r1: 'The queue fills up with excited tourists.',
  evt_tv_coverage_name: 'TV Crew Request',
  evt_tv_coverage_desc: 'A local TV station wants to cover your haunted house.',
  evt_tv_coverage_c1: 'Accept (risky)',
  evt_tv_coverage_c2: 'Decline',
  evt_tv_coverage_r1: 'The coverage aired. Results vary...',
  evt_tv_coverage_r2: 'You politely declined the offer.',
  evt_spy_name: 'Rival Spy',
  evt_spy_desc: 'You spot someone suspiciously taking notes about your operations.',
  evt_spy_c1: 'Apprehend (need security)',
  evt_spy_c2: 'Ignore',
  evt_spy_r1: 'The spy was caught. You recovered valuable intel.',
  evt_spy_r2: 'Some of your ideas might leak to competitors.',
  evt_health_inspection_name: 'Health Inspection',
  evt_health_inspection_desc: 'Health inspectors arrive for a surprise visit.',
  evt_health_inspection_c1: 'Open the doors',
  evt_health_inspection_r1: 'The inspection is complete.',
  evt_halloween_season_name: 'Halloween Fever',
  evt_halloween_season_desc: 'Halloween spirit fills the air! Everyone is in the mood for scares.',
  evt_halloween_season_c1: 'Celebrate!',
  evt_halloween_season_r1: 'Halloween boost! Extra visitors and SP incoming.',
  evt_ghost_strike_name: 'Ghost Strike',
  evt_ghost_strike_desc: 'Overworked ghosts are refusing to scare. They demand better conditions.',
  evt_ghost_strike_c1: 'Pay bonus (500 SP)',
  evt_ghost_strike_c2: 'Wait it out',
  evt_ghost_strike_r1: 'The bonus satisfied the ghosts. Back to work!',
  evt_ghost_strike_r2: 'The strike continues for a while...',
  evt_mystery_visitor_name: 'Mystery Critic',
  evt_mystery_visitor_desc: 'A famous horror critic is visiting in disguise. Results depend on your reputation.',
  evt_mystery_visitor_c1: 'Best behavior',
  evt_mystery_visitor_r1: 'The critic revealed themselves and wrote a review.',
  evt_maintenance_accident_name: 'Equipment Malfunction',
  evt_maintenance_accident_desc: 'A piece of equipment malfunctioned in one of the rooms!',
  evt_maintenance_accident_c1: 'Assess damage',
  evt_maintenance_accident_r1: 'A room sustained damage. Repairs needed.',
  evt_sns_viral_name: 'Viral Video',
  evt_sns_viral_desc: 'A visitor\'s video of your haunted house went viral online!',
  evt_sns_viral_c1: 'Ride the wave',
  evt_sns_viral_r1: 'Your fame skyrockets! Reputation and SP boosted.',
  evt_total_blackout_name: 'Total Blackout',
  evt_total_blackout_desc: 'All power goes out across the entire area. Complete darkness.',
  evt_total_blackout_c1: 'Candlelight event (+Rep)',
  evt_total_blackout_c2: 'Wait for power',
  evt_total_blackout_r1: 'The candlelight atmosphere was a hit!',
  evt_total_blackout_r2: 'Everyone waited in the dark.',
  evt_famous_youtuber_name: 'Famous Streamer',
  evt_famous_youtuber_desc: 'A famous horror streamer with millions of followers is live-streaming from your haunted house!',
  evt_famous_youtuber_c1: 'Give VIP treatment',
  evt_famous_youtuber_r1: 'The stream was a massive hit! Reputation +30, SP +2000.',
  evt_celeb_visit_name: 'Celebrity Visit',
  evt_celeb_visit_desc: 'A major celebrity has arrived for a private scare session!',
  evt_celeb_visit_c1: 'Roll out the red carpet',
  evt_celeb_visit_r1: 'The celebrity loved it! Huge publicity boost.',
  evt_franchise_offer_name: 'Franchise Offer',
  evt_franchise_offer_desc: 'A corporation wants to franchise your haunted house brand.',
  evt_franchise_offer_c1: 'Accept (10000 SP)',
  evt_franchise_offer_c2: 'Decline',
  evt_franchise_offer_r1: 'Deal signed! A hefty payment arrives.',
  evt_franchise_offer_r2: 'You prefer to stay independent.',
  evt_intl_contest_name: 'International Horror Contest',
  evt_intl_contest_desc: 'Your haunted house is invited to an international scare competition!',
  evt_intl_contest_c1: 'Enter the contest',
  evt_intl_contest_r1: 'You earned recognition on the world stage!',
  evt_documentary_name: 'Documentary Filming',
  evt_documentary_desc: 'A documentary crew wants to film the story of your haunted house.',
  evt_documentary_c1: 'Allow filming',
  evt_documentary_r1: 'The documentary premieres to rave reviews!',
  evt_ghost_king_name: 'The Ghost King Appears',
  evt_ghost_king_desc: 'A legendary ghost is drawn to your haunted house by its fame.',
  evt_ghost_king_c1: 'Welcome the Ghost King',
  evt_ghost_king_r1: 'The Ghost King joins your ranks! Morale soars.',
  evt_gov_subsidy_name: 'Government Grant',
  evt_gov_subsidy_desc: 'The tourism board awards your haunted house a cultural preservation grant.',
  evt_gov_subsidy_c1: 'Accept the grant',
  evt_gov_subsidy_r1: 'Grant received: 5000 SP!',
  evt_vip_party_name: 'VIP Party Request',
  evt_vip_party_desc: 'A wealthy patron wants to rent the entire haunted house for a private party.',
  evt_vip_party_c1: 'Accept (8000 SP)',
  evt_vip_party_c2: 'Decline',
  evt_vip_party_r1: 'The VIP party was a huge success!',
  evt_vip_party_r2: 'You keep the doors open for regular visitors.',
  evt_horror_festival_name: 'Horror Festival',
  evt_horror_festival_desc: 'The city is hosting a horror festival and your haunted house is the main attraction!',
  evt_horror_festival_c1: 'Lead the festival',
  evt_horror_festival_r1: 'The festival was legendary! Massive rewards earned.',
  evt_legendary_review_name: 'Legendary Review',
  evt_legendary_review_desc: 'The world\'s most famous horror critic publishes a glowing review of your haunted house.',
  evt_legendary_review_c1: 'Bask in glory',
  evt_legendary_review_r1: 'A flood of 5-star reviews and fame follows!',

  // === Event Defense System ===
  evt_defense_badge: 'Auto-Resolved!',
  evt_defense_bonus: 'Bonus: +{sp} SP',
  evt_rain_defense: 'The roof upgrade keeps everyone dry. No one leaves!',
  evt_rain_hint: 'Tip: Upgrade Poster Wall to Lv.3 to auto-defend against rain.',
  evt_couple_fight_defense: 'Security steps in and mediates the situation calmly.',
  evt_couple_fight_hint: 'Tip: Hire a Security guard to auto-resolve fights.',
  evt_crying_child_defense: 'The snack cart attendant offers candy. The child smiles!',
  evt_crying_child_hint: 'Tip: Build a Snack Cart to automatically comfort crying children.',
  evt_blackout_defense: 'Emergency generators kick in automatically. No interruption!',
  evt_blackout_hint: 'Tip: Upgrade facilities to total Lv.10+ for backup power.',
  evt_line_cutter_defense: 'Security handles the line cutter immediately. Order restored!',
  evt_line_cutter_hint: 'Tip: Hire a Security guard to auto-handle line cutters.',
  evt_fake_ghost_defense: 'Your real NPC ghosts outshine the impostor. Excitement rises!',
  evt_fake_ghost_hint: 'Tip: Assign at least 1 NPC ghost to the lobby to overshadow fakers.',
  evt_lost_item_defense: 'Your staff quickly locates and returns the lost item!',
  evt_lost_item_hint: 'Tip: Hire 3+ staff members to auto-find lost items.',
  evt_snack_sold_out_defense: 'Inventory auto-restocked from reserves. Sales continue!',
  evt_snack_sold_out_hint: 'Tip: Upgrade Snack Cart to Lv.2+ for auto-restocking.',
  evt_sns_selfie_defense: 'Photo Zone provides the perfect backdrop. Great shots posted!',
  evt_sns_selfie_hint: 'Tip: Build a Photo Zone for automatic photo opportunities.',
  evt_hot_weather_defense: 'The monitor area has air conditioning. Everyone stays cool!',
  evt_hot_weather_hint: 'Tip: Install a TV Monitor to provide a cooled waiting area.',
  evt_tour_bus_defense: 'Plenty of room! All tourists are welcomed in.',
  evt_tour_bus_hint: 'Tip: Expand queue capacity to 15+ to accept large groups.',
  evt_tv_coverage_defense: 'With great reputation and many ghosts, the broadcast is a hit!',
  evt_tv_coverage_hint: 'Tip: Reach reputation 50+ and hire 5+ ghosts for guaranteed success.',
  evt_spy_defense: 'Security catches the spy red-handed! Intel recovered.',
  evt_spy_hint: 'Tip: Hire a Security guard to auto-detect spies.',
  evt_health_inspection_defense: 'Spotless! The inspector awards a hygiene certificate.',
  evt_health_inspection_hint: 'Tip: Hire a Janitor and keep average hygiene above 70.',
  evt_ghost_strike_defense: 'Ghosts are well-rested and happy. No strike today!',
  evt_ghost_strike_hint: 'Tip: Keep average ghost fatigue below 30 to prevent strikes.',
  evt_mystery_visitor_defense: 'Your excellent reputation earns a glowing review!',
  evt_mystery_visitor_hint: 'Tip: Maintain reputation at 60+ for guaranteed good reviews.',
  evt_maintenance_accident_defense: 'The repairman fixes it on the spot. Minimal damage!',
  evt_maintenance_accident_hint: 'Tip: Hire a Repairman to minimize equipment damage.',
  evt_total_blackout_defense: 'Repairman restores power instantly. Candle event bonus!',
  evt_total_blackout_hint: 'Tip: Hire a Repairman and reach facility Lv.15+ total.',
  evt_vip_party_defense: 'Costumes and photo zone make the party unforgettable! Normal business continues too.',
  evt_vip_party_hint: 'Tip: Build Costume Rental and Photo Zone for the ultimate party.',

  // === World Street ===
  world_title: 'Edificios',
  world_subtitle: 'Selecciona un edificio para gestionar',
  world_empty_plot: 'Terreno vacio',
  world_build_new: 'Construir una nueva casa embrujada tematica',

  rename_building: 'Renombrar edificio',
  rename_building_desc: 'Introduce el nuevo nombre',
  rename: 'Cambiar',
  building_renamed: 'Nombre cambiado',

  construction_title: 'Nuevo edificio',
  construction_subtitle: 'Construye una nueva casa embrujada!',
  construction_name_label: 'Nombre',
  construction_name_placeholder: 'Ej: Mansión nocturna',
  construction_theme_label: 'Tema',
  construction_start: 'Construir',
  world_status_build: 'Construir',
  world_status_open: 'Abierto',
  world_status_ready: 'Preparado',
  theme_haunted_house: 'Casa embrujada',
  theme_haunted_house_desc: 'Experiencia clásica de fantasmas',
  theme_abandoned_hospital: 'Hospital abandonado',
  theme_abandoned_hospital_desc: 'Terror médico y ambiente de laboratorio',
  theme_school_back_mountain: 'Montaña detrás de la escuela',
  theme_school_back_mountain_desc: 'Leyendas escolares y senderos tenebrosos',
  theme_cursed_circus: 'Circo maldito',
  theme_cursed_circus_desc: 'Horror bizarro de un circo maldito',
  theme_ancient_temple: 'Templo antiguo',
  theme_ancient_temple_desc: 'Maldiciones místicas de un templo antiguo',
  theme_pirate_ship: 'Barco pirata',
  theme_pirate_ship_desc: 'Horror marino de un barco pirata maldito',
  theme_abandoned_mine: 'Mina abandonada',
  theme_abandoned_mine_desc: 'Horror oscuro y profundo de una mina abandonada',
  theme_gothic_castle: 'Castillo gótico',
  theme_gothic_castle_desc: 'Horror aristocrático elegante y siniestro',
  theme_underground_bunker: 'Búnker subterráneo',
  theme_underground_bunker_desc: 'Experimentos y conspiraciones bajo tierra',
  theme_cursed_forest: 'Bosque maldito',
  theme_cursed_forest_desc: 'Espíritus naturales y horror primitivo',

  synergy_active_count: '{n} Sinergias Activas',
  synergy_popup_title: 'Sinergias Activas',
  syn_fx_dark_mirror_e1: 'Ilusion del Espejo',
  syn_fx_dark_mirror_e2: 'Maldicion del Doble',
  syn_fx_underground_horror_e1: 'Grito de la Mazmorra',
  syn_fx_underground_horror_e2: 'Eco de la Muerte',
  syn_fx_restless_spirits_e1: 'Suspiro de los Muertos',
  syn_fx_restless_spirits_e2: 'Procesion Fantasma',
  syn_fx_creepy_collection_e1: 'Maldicion de las Munecas',
  syn_fx_creepy_collection_e2: 'Laberinto de Espejos',
  syn_fx_mad_scientist_e1: 'Experimento Loco',
  syn_fx_mad_scientist_e2: 'Recompensa Alquimica',
  syn_fx_hidden_paths_e1: 'Laberinto de Sombras',
  syn_fx_hidden_paths_e2: 'Terror Oculto',
  syn_fx_circus_nightmare_e1: 'Juego del Payaso',
  syn_fx_circus_nightmare_e2: 'Pesadilla del Circo',
  syn_fx_ancient_curse_e1: 'Maldicion Antigua',
  syn_fx_ancient_curse_e2: 'Furia de la Momia',
  syn_fx_hidden_treasures_e1: 'Tentacion del Tesoro',
  syn_fx_hidden_treasures_e2: 'Descubrimiento Subterraneo',
  syn_fx_ship_of_doom_e1: 'Canto Funebre del Mar',
  syn_fx_ship_of_doom_e2: 'Castigo de Davy Jones',
  syn_fx_prison_horror_e1: 'Escape de Prision',
  syn_fx_prison_horror_e2: 'Cadenas de Opresion',
  syn_fx_deep_descent_e1: 'Brillo Cristalino',
  syn_fx_deep_descent_e2: 'Misterio Subterraneo',
  syn_fx_boom_scare_e1: 'Estela de Explosion',
  syn_fx_boom_scare_e2: 'Explosion en Cadena',
  syn_fx_royal_terror_e1: 'Ira del Rey',
  syn_fx_royal_terror_e2: 'Tesoro Real',
  syn_fx_noble_cellar_e1: 'Aroma Anejado',
  syn_fx_noble_cellar_e2: 'Bodega Secreta',
  syn_fx_quarantine_protocol_e1: 'Alerta de Cuarentena',
  syn_fx_quarantine_protocol_e2: 'Amenaza Biologica',
  syn_fx_nature_wrath_e1: 'Niebla de Bruja',
  syn_fx_nature_wrath_e2: 'Furia Natural',
  syn_fx_ancient_power_e1: 'Fuerza Ancestral',
  syn_fx_ancient_power_e2: 'Ruinas Mistica',
  syn_fx_echo_chamber_e1: 'Maldicion del Eco',
  syn_fx_echo_chamber_e2: 'Ilusion Sonora',
  syn_fx_water_horror_e1: 'Terror del Abismo',
  syn_fx_water_horror_e2: 'Susurro del Agua',
  syn_fx_full_course_e1: 'Banquete Completo',
  syn_fx_full_course_e2: 'Sonrisa de Satisfaccion',
  synergy_dark_mirror: 'Espejo Oscuro',
  synergy_dark_mirror_desc: 'Pasillo oscuro + Sala de espejos: Atmsfera +15%, Miedo +10%',
  synergy_underground_horror: 'Horror Sub the underground_hor',
  synergy_underground_horror_desc: 'Mazmorras/Ataud combination: Miedo +20%, Thrill +10%',
  synergy_restless_spirits: 'Espritus不安',
  synergy_restless_spirits_desc: 'Cementerio/Ataud/Morgue: atmsphere +20%, visitors +10%',
  synergy_creepy_collection: 'Coleccin creepy',
  synergy_creepy_collection_desc: 'Muecas/espejo/Funhouse: Miedo +15%, Thrill +10%',
  synergy_mad_scientist: 'Cientfico loco',
  synergy_mad_scientist_desc: 'Lab/Quirófano/Ciencia: Thrill +20%, SP +15%',
  synergy_hidden_paths: 'Caminos ocultos',
  synergy_hidden_paths_desc: 'Pasaje oscuro/Pasillo/tico: atmsfera +15%, Cadena +20%',
  synergy_circus_nightmare: 'Pesadilla del circo',
  synergy_circus_nightmare_desc: 'Funhouse/Freak Show/Trapecio: Diversin +20%, Miedo +15%',
  synergy_ancient_curse: 'Maldicin antigua',
  synergy_ancient_curse_desc: 'Altar/Maldicion/Tumba: Miedo +25%, Thrill +15%',
  synergy_hidden_treasures: 'Tesoros ocultos',
  synergy_hidden_treasures_desc: 'Vida subterranea + SP +20%, visitantes +10%',
  synergy_ship_of_doom: 'Barco de la muerte',
  synergy_ship_of_doom_desc: 'Capitan/Carga/Davy: atmsfera +15%, Miedo +15%',
  synergy_prison_horror: 'Horror carcelario',
  synergy_prison_horror_desc: 'Brig + Davy: Thrill +20%, Amenaza +10%',
  synergy_deep_descent: 'Descenso profundo',
  synergy_deep_descent_desc: 'Mina/Cristal/Lago: atmsfera +20%, visitantes +15%',
  synergy_boom_scare: 'Susto explosivo',
  synergy_boom_scare_desc: 'Explosivos + Tunel: Thrill +25%, Cadena +15%',
  synergy_royal_terror: 'Terror real',
  synergy_royal_terror_desc: 'Trono/Torre/Vino: Miedo +15%, SP +20%',
  synergy_noble_cellar: 'Stilago noble',
  synergy_noble_cellar_desc: 'Bodega + Pasaje: atmsfera +15%, SP +10%',
  synergy_quarantine_protocol: 'Protocolo de cuarentena',
  synergy_quarantine_protocol_desc: 'Servidor/Cuarentena/Armeria: Thrill +20%, Miedo +10%',
  synergy_nature_wrath: 'Furia de la naturaleza',
  synergy_nature_wrath_desc: 'Bruja/Pantano/Hada: atmsfera +20%, Amenaza +10%',
  synergy_ancient_power: 'Poder antiguo',
  synergy_ancient_power_desc: 'Ruinas/Hada/Altar: Miedo +20%, visitantes +15%',
  synergy_echo_chamber: 'Camara de eco',
  synergy_echo_chamber_desc: 'Musica/Biblioteca/Pasillo: Cadena +25%, atmsfera +10%',
  synergy_water_horror: 'Horror acutico',
  synergy_water_horror_desc: 'Bano/Rio subterraneo/Lago: Miedo +15%, atmsfera +15%',
  synergy_full_course: 'Menu completo',
  synergy_full_course_desc: 'Cocina/Bano/Musica: Diversin +25%, visitantes +20%',
};

export default es;
